module.exports = __webpack_public_path__ + "img/calendar-check-orange.c4511cbf.svg";